import { Component, Input, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { SupportedCurrencies } from '@models/currency-list';

@Component({
  selector: 'app-currency-icon',
  standalone: true,
  imports: [],
  templateUrl: './currency-icon.component.html',
  styleUrls: ['./currency-icon.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CurrencyIconComponent {

  @Input() currency;
  currencies = SupportedCurrencies;
  symbolObj;

  ngOnChanges(change: SimpleChanges): void {
    if (change && change.currency.currentValue && change.currency.currentValue) {
      this.symbolObj = this.currencies.find((item) => item.currency === this.currency?.toUpperCase());
    }
  }

}
